var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
function SvgHomeSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#8e8d9c"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12.5 1C18.8 1 24 6.2 24 12.5S18.8 24 12.5 24 1 18.8 1 12.5 6.2 1 12.5 1m0-1C5.6 0 0 5.6 0 12.5S5.6 25 12.5 25 25 19.4 25 12.5 19.4 0 12.5 0z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.1 10.7l-1.7-1.5V6.5c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5v1.4L13.2 5c-.4-.3-1-.3-1.3 0l-7 5.7c-.2.2-.2.4-.1.6.2.2.4.2.6.1l1.1-.9v7.3c0 .7.6 1.2 1.2 1.2h9.4c.7 0 1.2-.6 1.2-1.2v-7.3l1.1.9c.1.1.2.1.3.1.1 0 .3-.1.3-.2.3-.1.3-.4.1-.6zm-2.6 7c0 .2-.1.3-.3.3h-3v-4.2c0-.3-.2-.5-.5-.5h-2.4c-.3 0-.5.2-.5.5V18h-3c-.2 0-.3-.1-.3-.3v-8l5-4h.1l5 4v8z"
  }))));
}
export default SvgHomeSelected;